import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "d-flex min-width-0 pb-1 w-100 mw-100 counter-row" }
const _hoisted_2 = { class: "text-right pl-3" }

import SystemStateInterface, {SystemStateGroupInterface} from "~/cabinet/vue/layout/lcab/SystemStateInterface";
import ElCardHeader from "~/cabinet/vue/interface/card/ElCardHeader.vue";
import ElCardSection from "~/cabinet/vue/interface/card/ElCardSection.vue";
import {computed, ref} from "vue";
import ReactiveRequest from "~/core-ui/ts/request/ReactiveRequest";
import LcabApiRequest from "~/cabinet/ts/api/LcabApiRequest";
import ReactiveRequestLoader from "~/cabinet/vue/interface/data/ReactiveRequestLoader.vue";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import DaemonCountRow from "~/cabinet/vue/layout/lcab/systemStateCounters/DaemonCountRow.vue";
import Dictionary from "~/ts/library/Dictionary";


const __default__ = {
    name: "SystemStateCounters"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    systemState: {}
  },
  setup(__props: any) {

let props = __props;

let groupCollapseState = ref<Dictionary<boolean>>({});

let currentRowLogDialog = ref<{
    visible: boolean,
    daemonName: string,
    className: string
}>();

let currentRowLogRequest = computed(() => {
    let dialog = currentRowLogDialog.value
    if (dialog?.visible) {
        return new ReactiveRequest<{ item: string, formattedLog?: string }>(new LcabApiRequest({
            url: `/api/superdealer/dev/php/getCurrentDaemonRowLog`,
            p: {
                daemonName: dialog.daemonName,
                className: dialog.className
            }
        }));
    }
    return null;
})

function onItemClick(daemonName: string, isClickable: boolean, className: string) {
    if (isClickable) {
        currentRowLogDialog.value = {
            visible: true,
            daemonName,
            className
        };
    }
}

function isCriticalByGroup(group: SystemStateGroupInterface) {
    for (let key in group.values) {
        if (group.values.hasOwnProperty(key)) {
            let value = group.values[key];
            let criticalCount = group.criticalCount[key];
            if (criticalCount && criticalCount <= value) {
                return true;
            }
        }
    }
    return false;
}

function getSumGroupCount(group: SystemStateGroupInterface): number {
    let result = 0;
    for (let key in group.values) {
        if (group.values.hasOwnProperty(key)) {
            result += group.values[key];
        }
    }
    return result;
}

return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_row, {
      class: "el-row-root",
      gutter: 20
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.systemState.queues, (item, key) => {
          return (_openBlock(), _createBlock(_component_el_col, {
            key: item.descr,
            md: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, null, {
                default: _withCtx(() => [
                  _createVNode(ElCardHeader, {
                    title: item.descr
                  }, null, 8, ["title"]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.groups, (group) => {
                    return (_openBlock(), _createBlock(ElCardSection, {
                      key: group.className,
                      class: "p-0"
                    }, {
                      default: _withCtx(() => [
                        (group.count > 1)
                          ? (_openBlock(), _createBlock(DaemonCountRow, {
                              key: 0,
                              descr: "",
                              value: getSumGroupCount(group),
                              critical: isCriticalByGroup(group),
                              clickable: "",
                              onClick: ($event: any) => (_unref(groupCollapseState)[group.className] = !_unref(groupCollapseState)[group.className])
                            }, {
                              descr: _withCtx(() => [
                                _createVNode(FontAwesomeIcon, {
                                  icon: _unref(groupCollapseState)[group.className] ? 'chevron-down' : 'chevron-right',
                                  class: "mr-1"
                                }, null, 8, ["icon"]),
                                _createTextVNode(" " + _toDisplayString(group.defaultName), 1)
                              ]),
                              _: 2
                            }, 1032, ["value", "critical", "onClick"]))
                          : _createCommentVNode("", true),
                        (group.count <= 1 || _unref(groupCollapseState)[group.className])
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(group.values, (value, key) => {
                              return (_openBlock(), _createBlock(DaemonCountRow, {
                                descr: key.startsWith(group.defaultName+'_') ? key.substring(group.defaultName.length + 1)  : key,
                                critical: value > group.criticalCount[key],
                                small: group.count > 1,
                                value: value,
                                clickable: group.isLogCurrentRow.includes(key),
                                rps: group.rps[key],
                                onClick: ($event: any) => (onItemClick(key, group.isLogCurrentRow.includes(key), group.className))
                              }, null, 8, ["descr", "critical", "small", "value", "clickable", "rps", "onClick"]))
                            }), 256))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 2
              }, 1024),
              (key===1)
                ? (_openBlock(), _createBlock(_component_el_card, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(ElCardSection, { class: "pt-2 pb-2" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_1, [
                            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex-fill" }, " Клиентов онлайн ", -1)),
                            _createElementVNode("div", _hoisted_2, _toDisplayString(__props.systemState.currentOnline), 1)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    (_unref(currentRowLogDialog) && _unref(currentRowLogDialog).visible)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          title: _unref(currentRowLogDialog).daemonName,
          modelValue: _unref(currentRowLogDialog).visible,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(currentRowLogDialog).visible) = $event)),
          "custom-class": "body-background",
          width: "1200px"
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_el_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(currentRowLogRequest).make()))
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode(" Обновить ", -1)
              ]))]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(ReactiveRequestLoader, { request: _unref(currentRowLogRequest) }, {
              default: _withCtx(() => [
                (_unref(currentRowLogRequest).data)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_unref(currentRowLogRequest).data.formattedLog)
                        ? (_openBlock(), _createBlock(_component_el_card, {
                            key: 0,
                            class: "mb-4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(ElCardHeader, { title: "Отформатированное значение" }),
                              _createVNode(ElCardSection, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("pre", null, _toDisplayString(_unref(currentRowLogRequest).data.formattedLog), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_card, null, {
                        default: _withCtx(() => [
                          _createVNode(ElCardHeader, { title: "Оригинал" }),
                          _createVNode(ElCardSection, null, {
                            default: _withCtx(() => [
                              _createElementVNode("pre", null, _toDisplayString(_unref(currentRowLogRequest).data.item), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["request"])
          ]),
          _: 1
        }, 8, ["title", "modelValue"]))
      : _createCommentVNode("", true)
  ]))
}
}

})